import {Deal} from "@irati/types"

export default function isCompanyBenefit(deal: Deal) {
  return deal.type === "COMPANY"
}
